import React, { memo } from 'react'
import Slider from 'root/src/client/web/base/Slider'
import length from 'ramda/src/length'
import withStyles from '@material-ui/core/styles/withStyles'
import addIndex from 'ramda/src/addIndex'
import map from 'ramda/src/map'
import Link from 'root/src/client/web/base/Link'
import ButtonNew from 'root/src/client/web/base/ButtonNew'
import classNames from 'classnames'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import FormTitle from 'root/src/client/web/typography/FormTitle'
import MaxWidthContainer from 'root/src/client/web/base/MaxWidthContainer'
import styles from './styles'

const StepperHeaderComponent = ({
	stepperHeaderItems, buttons, isMobileRes, sliderWidth, tabs, classes,
	buttonWithHover, oauthedPlatforms, isAuthenticated, isBrandUser, maxWidth, ...props
}) => (
	<div className={classNames(
		classes.root,
		maxWidth && classes.maxWidth,
	)}
	>
		<MaxWidthContainer>
			<Slider
				captions
				dots
				isDraggable
				sliderWidth={sliderWidth}
				sliderItems={stepperHeaderItems}
				dragActive={isMobileRes}
				sliderItemsStyle={classes.sliderItems}
				renderCaption={({ subHeading }, idx) => (
					<div key={idx} className={classes.textItemContainer}>
						<div className={classes.textItem}>
							<div className={classes.itemSubHeadingContainer}>
								<span className={classes.itemSubHeading}>
									{subHeading}
								</span>
							</div>
						</div>
					</div>
				)}
				{...props}
			>
				{addIndex(map)(({ image, heading, routeId }, index) => (
					<div
						className={classes.slideContainer}
						key={index}
					>
						<div className={classes.arrowRectContainer} />
						<div className={classes.itemContainer}>
							<div className={classes.itemHeadingContainer}>
								<FormTitle>
									{heading}
								</FormTitle>
							</div>
							<div className={classes.item}>
								{(routeId && !isMobileRes)
									? (
										<Link routeId={routeId}>
											<LazyLoadImage className={classes.image} src={image.src} alt={heading} />
										</Link>
									)
									: <LazyLoadImage className={classes.image} src={image.src} alt={heading} />
								}
							</div>
						</div>
						{index < length(stepperHeaderItems) - 1
							? (
								<div className={classNames(
									classes.itemContainer,
									classes.arrowRectContainer,
									index === length(stepperHeaderItems) - 1 && classes.hide,
								)}
								>
									<div className={classNames(
										classes.arrowRect,
										classes.arrowRectRight,
									)}
									/>
								</div>
							)
							: (
								<div className={classes.arrowRectContainer} />
							)}
					</div>
				), stepperHeaderItems)}
			</Slider>
		</MaxWidthContainer>
		{buttons && (
			<div className={classes.buttonsContainer}>
				{map(({ text, routeId, type, href }) => (
					<div className={classes.btnContainer} key={text}>
						<Link
							routeId={routeId}
							href={href}
						>
							<ButtonNew
								buttonType={type}
							>
								{text}
							</ButtonNew>
						</Link>
					</div>
				), buttons)}
			</div>
		)}
	</div>
)

export default withStyles(styles, { name: 'MuiStepperHeaderComponent' })(memo(StepperHeaderComponent))
